import React, { useState, useEffect } from 'react';
import './ContactBanner.css';
import Btn from '../common/btn';
import as from '../../asserts/ast.png';
import as1 from '../../asserts/ast.png';
import { supabase } from '../../supabaseClient';

const ContactBanner = () => {
  const [cto, setCto] = useState(null);

  useEffect(() => {
    const getCto = async () => {
      const res = await supabase.from('about_section_cta').select('*').single();
      setCto(res.data || null);
    };
    getCto();
  }, []);

  return (
    <section className="contact-banner-section">
      <div className="contact-banner">
        <h2 className="contact-banner-title">{cto?.title_en || ''}</h2>
        <p className="contact-banner-text">{cto?.content_en || ''}</p>
        <a href="*" className="contact-banner-link">
          <Btn btnt={cto?.button_text_en || ''} />
        </a>
      </div>
      <img src={as} alt="Decorative design element" className='as' />
      <img src={as1} alt="Decorative design element" className='as1' />
    </section>
  );
};

export default ContactBanner;